import { Flex } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import {
    useLocation,
    useMatch,
    useNavigate,
    useParams,
} from 'react-router-dom';
import CanopyTabs from '../../canopy-ui-components/components/CanopyTabs/CanopyTabs';
import { useCurrentColors } from '../../canopy-ui-components/hooks/UseCurrentColors/UseCurrentColors';
function PagesWithTabs({
    isNavBarExpanded,
    tabs,
    t,
    children,
    isBannerShown,
}: any) {
    const currentColors = useCurrentColors();
    const router = useNavigate();
    const params = useParams();
    const { pathname, state } = useLocation();
    const { params: matchedParams } =
        useMatch({
            path: '/:level1/:level2/:level3/',
            end: true,
        }) || {};
    let defaultIndex = tabs?.findIndex(({ path }: any) => {
        const currentPath = path?.split('/');
        currentPath?.shift();
        if (currentPath.length > 0 && matchedParams) {
            return (
                currentPath.every(
                    (cp: string, index: number) =>
                        cp === (matchedParams as any)?.[`level${index + 1}`]
                ) || pathname === path
            );
        }
        return pathname === path;
    });
    const topPosition = isNavBarExpanded ? 130 : 70;
    return (
        <Flex
            minHeight={
                isNavBarExpanded ? 'calc(100vh - 175px)' : 'calc(100vh - 115px)'
            }
            top={`${isBannerShown ? topPosition + 75 : topPosition}px`}
            position="relative"
            overflow="visible"
            p="4px"
            flexGrow={1}
        >
            {tabs.length > 0 && (
                <CanopyTabs
                    isNavBarExpanded={isNavBarExpanded}
                    isBannerShown={isBannerShown}
                    tabList={tabs}
                    activeTabIndex={defaultIndex}
                    onTabSelect={(path: any) => {
                        router(path);
                    }}
                    globalProps={{
                        redirectTo: (
                            url: string,
                            options?: Record<string, any>
                        ) => {
                            options = options || {};
                            url && router(url, { ...options });
                        },
                        t,
                        qp: state,
                    }}
                >
                    {React.cloneElement(children, {
                        t,
                    })}
                </CanopyTabs>
            )}
        </Flex>
    );
}

PagesWithTabs.propTypes = {
    t: PropTypes.func.isRequired,
};

export default withTranslation('translations')(PagesWithTabs);
